import api from './api';

export interface PickingPedidoPendiente {
  nroFormulario: number;
  fechaEmision?: string | null;
  letra?: string | null;
  nroSuc: number;
  nroComprobante?: number | null;
  nroCliente?: number | null;
  nombre?: string | null;
  importeTotal?: number | null;
  pickingIniciado: boolean;
}

export interface PickingItem {
  nroItem: number;
  codigoArticulo?: string | null;
  descripcion?: string | null;
  codBarra?: string | null;
  cantidadPedida: number;
  cantidadPickeada: number;
  cantidadPendiente: number;
}

export interface PickingPedidoDetalle {
  nroFormulario: number;
  fechaEmision?: string | null;
  letra?: string | null;
  nroSuc: number;
  nroComprobante?: number | null;
  nroCliente?: number | null;
  nombre?: string | null;
  importeTotal?: number | null;
  asentado?: string | null;
  modoCodigoBarra: boolean;
  totalPedido: number;
  totalPickeado: number;
  totalPendiente: number;
  completo: boolean;
  items?: PickingItem[] | null;
}

export interface PickingLecturaResult {
  codigoArticulo?: string | null;
  descripcion?: string | null;
  cantidadAplicada: number;
  cantidadPedida: number;
  cantidadPickeada: number;
  cantidadPendiente: number;
  pedido: PickingPedidoDetalle;
}

export interface PickingEvento {
  id: number;
  fechaHora: string;
  codigoArticulo?: string | null;
  descripcion?: string | null;
  cantidad?: number | null;
  usuario?: string | null;
  evento?: string | null;
}

export interface PickingPedidoEspera {
  nroFormulario: number;
  letra?: string | null;
  nroSuc: number;
  nroComprobante?: number | null;
  importeTotal?: number | null;
  items?: PickingItem[] | null;
}

export interface PickingListoResult {
  nroFormulario: number;
  asentado?: string | null;
  parcial: boolean;
  pedidoEnEspera?: PickingPedidoEspera | null;
}

export interface PickingPendientesSearch {
  nroCliente?: number;
  busqueda?: string;
}

const pickingVentaService = {
  getPendientes: async (params: PickingPendientesSearch = {}): Promise<PickingPedidoPendiente[]> => {
    const response = await api.get<PickingPedidoPendiente[]>('/api/PickingVentas/pendientes', {
      params: {
        nroCliente: params.nroCliente && params.nroCliente > 0 ? params.nroCliente : undefined,
        busqueda: params.busqueda?.trim() || undefined,
      },
    });
    return response.data ?? [];
  },

  getDetalle: async (id: number): Promise<PickingPedidoDetalle> => {
    const response = await api.get<PickingPedidoDetalle>(`/api/PickingVentas/${id}`);
    return response.data;
  },

  leer: async (id: number, codigo: string, cantidad?: number): Promise<PickingLecturaResult> => {
    const response = await api.post<PickingLecturaResult>(`/api/PickingVentas/${id}/leer`, {
      codigo,
      cantidad: cantidad && cantidad > 0 ? cantidad : null,
    });
    return response.data;
  },

  deshacer: async (id: number, codigoArticulo: string, cantidad: number): Promise<PickingPedidoDetalle> => {
    const response = await api.post<PickingPedidoDetalle>(`/api/PickingVentas/${id}/deshacer`, {
      codigoArticulo,
      cantidad,
    });
    return response.data;
  },

  getEventos: async (id: number): Promise<PickingEvento[]> => {
    const response = await api.get<PickingEvento[]>(`/api/PickingVentas/${id}/eventos`);
    return response.data ?? [];
  },

  listo: async (id: number, confirmarParcial: boolean): Promise<PickingListoResult> => {
    const response = await api.post<PickingListoResult>(`/api/PickingVentas/${id}/listo`, {
      confirmarParcial,
    });
    return response.data;
  },
};

export default pickingVentaService;
